const resetState = {
	appid: '',
};

const actions = {
	async updateAppBaseInfo({ commit, state, rootState }, payload) {
		commit('UPDATE_APP_BASE_INFO', {
			appid: payload.appid,
		});
	},

	async resetAppState({ commit, state, rootState }, payload) {
		commit('UPDATE_APP_BASE_INFO', {
			...resetState
		});
	},
}

export default actions;
